import axios from 'axios'
import jwtDecode from 'jwt-decode'
/* globals localStorage */

export default {
  refresh: false,
  login (email, password) {
    return new Promise((resolve, reject) => {
      if (localStorage.token) {
        this.onChange(this.loggedIn(), this.isAdmin())
        resolve('aready logged in')
      }

      axios.post('/api/v1/auth', {
        email,
        password
      })
        .then((response) => {
          if (response.data.token && response.data.success) {
            console.log('Authentication success', JSON.stringify(localStorage))
            localStorage.token = response.data.token
            console.log('localStorage', JSON.stringify(localStorage))
            this.onChange(this.loggedIn(), this.isAdmin())
            resolve()
          }
        })
        .catch((error) => {
          console.log('Authentication failed', error.response.status)
          this.onChange(false, false)
          reject(error.response.data.message)
        })
    })
  },
  async requestNew (email, lang) {
    await axios.post('/api/v1/reset/request', { email, lang })
  },
  async checkResetToken (token) {
    let result = await axios.post('/api/v1/reset/check', { token })
    return result.data.success
  },
  async setNewPassword (token, password) {
    let result = await axios.post('/api/v1/reset/set', { token, password })
    return result.data.success
  },

  getToken () {
    return localStorage.token
  },
  setToken (token) {
    localStorage.token = token
  },

  decodeToken () {
    let decoded = false
    try {
      decoded = jwtDecode(this.getToken())
    } catch (err) {
      console.log(err)
    }
    console.log('decodeToken', JSON.stringify(decoded))
    return decoded
  },

  needRefresh () {
    if (!this.refresh) {
      this.refresh = true
      axios.post('/api/v1/auth/refresh', { token: localStorage.token })
        .then((response) => {
          if (response.data.token && response.data.success) {
            console.log('Token refreshed')
            localStorage.token = response.data.token
            this.refresh = false
          }
        })
        .catch(() => {
          console.log('Refresh failed')
        })
    }
  },

  logout () {
    localStorage.removeItem('token')
    console.log('localStorage after logout: ', JSON.stringify(localStorage))
    this.onChange(false, false)
  },

  loggedIn () {
    return Boolean(localStorage.token)
  },

  getEmail () {
    return (this.loggedIn()) ? this.decodeToken().email : 'Not logged in'
  },

  getFirstname () {
    return (this.loggedIn()) ? this.decodeToken().firstname : ''
  },

  getLastname () {
    return (this.loggedIn()) ? this.decodeToken().lastname : ''
  },

  isAdmin () {
    return (this.loggedIn()) ? this.decodeToken().admin : false
  },

  getUserId () {
    return (this.loggedIn()) ? this.decodeToken().id : 'Not logged in'
  },

  getExpTime () {
    return (this.loggedIn()) ? this.decodeToken().exp : 0
  },

  // value for the App.vue to show button "Sign-out"
  onChange () {}
}



// WEBPACK FOOTER //
// ./src/auth.js